import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() title: string = 'Home';
  
  constructor(private readonly router:Router, private readonly menu: MenuController, private readonly location: Location) {}

  public openMenu(){
    this.menu.open();
  }
  goBack() {
    this.router.navigate(['/news-announcements'])
  }
}
